import { render, staticRenderFns } from "./OffLineAgreement.vue?vue&type=template&id=5288f0ee&scoped=true"
import script from "./OffLineAgreement.vue?vue&type=script&lang=js"
export * from "./OffLineAgreement.vue?vue&type=script&lang=js"
import style0 from "./OffLineAgreement.vue?vue&type=style&index=0&id=5288f0ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5288f0ee",
  null
  
)

export default component.exports